/**
 * "Does deploying this agent need a human to decide something first?"
 *
 * ONE predicate, read by everyone who needs the answer — the marketplace's
 * `runDeploy` (to open the second step at all) and the second step itself (to
 * decide whether it has a configure section to render). A second copy of this
 * question would drift into the exact bug it was written to close: a template
 * declaring only `selections` never reached step 2 for weeks, because the gate
 * read `inputSchema` alone and nobody noticed that "declared choice" had grown
 * a second channel.
 *
 * IT SPANS BOTH CHANNELS ON PURPOSE, AND MERGES NEITHER. `deployInput` values
 * go to `body.defaultInput` (the per-run trigger payload); `selections` values
 * go to `body.selections` (the agent's encrypted env bag). The destinations
 * stay apart on the wire — see deploySelections.js. What is shared is the
 * QUESTION, and the dialog that asks it.
 *
 * DERIVED deploy-inputs do not count: the backend resolves those from their
 * `deriveFrom` source, so there is nothing to ask and a dialog offering
 * nothing is worse than no dialog.
 */

import { collectDeployInputFields } from './deployInputSources';
import { collectSelections } from './deploySelections';

/** The deploy-input fields a human must actually fill in. */
export function askableDeployInputFields(entry) {
  return collectDeployInputFields(entry?.inputSchema).filter((f) => !f.derived);
}

/** True when the deploy has a declared question for the operator. */
export function needsDeployConfig(entry) {
  return askableDeployInputFields(entry).length > 0
    || collectSelections(entry).length > 0;
}
